<template>
  <div class="inform-center">
    <div class="tab-box">
      <ul class="tabs">
        <li v-for="(i, index) in tabs" :key="index" :class="currentIndex == index? 'active': ''" @click="tabSelect(index)">{{i.name}}<a-badge class="item" color="#D55950" v-if="i.unread"/></li>
      </ul>
    </div>
    <div class="info-box">
      <div class="action-box">
        <a-checkbox v-model="checkAll" @change="onCheckAllChange">全选</a-checkbox>
        <span style="margin-left: 25px;cursor: pointer" @click="delAction"><a-icon type="delete" /> 删除</span>
        <a-button icon="edit" type="link" size="small" :disabled="ifDisabled" style="margin-left: 25px;cursor: pointer;float: right" @click="putMessageReady"> 全部标示为已读</a-button>
        <a-select v-model="selectVal" size="small" style="width: 95px;float: right;" @change="handleChange">
          <a-select-option value="2">
            全部消息
          </a-select-option>
          <a-select-option value="1">
            未读消息
          </a-select-option>
        </a-select>

        <a-select v-if="roleId == 'admin'" show-search allowClear option-filter-prop="children" placeholder="公司名称" size="small" style="width: 150px; margin-right:15px; float: right; " @change="selectCompanyAction">
           <a-select-option v-for="(item, index) in companyList" :key="index" :value="item.id">
             {{item.name}}
           </a-select-option>
        </a-select>
      </div>
      <div class="list-box" v-if="newsList.length > 0">
        <a-spin :spinning="loading">
          <div :class="n.unread? 'info-list': 'info-list gray'" v-for="(n, index) in newsList" :key="index">
            <p>
              <a-checkbox v-model="n.selected" :value="n.id" @change="onChange"></a-checkbox>
              <a-badge color="#D55950" v-if="n.unread" style="margin-left: 10px;font-size: 12px;"/>
              <a-badge color="#c1c1c1" v-else style="margin-left: 10px;font-size: 12px;"/>
              <span >{{n.title}}</span>
              <span v-if="roleId == 'admin'" class="til" >({{(n.deptName)}})</span>
            </p>
            <p :class="n.detailType ==1 || n.detailType == 2 || n.detailType == 4 || n.detailType == 3?'content pointer': 'content'" @click="goDetail(n)">{{n.content}} <i v-if="n.needDetail" style="color: #40a9ff">详情 >></i> </p>
            <span class="time">{{n.time}}</span>
          </div>
        </a-spin>
        <div class="pagination-layout">
          <a-pagination
            show-size-changer
            :current="page"
            :total="total"
            :pageSizeOptions="['10', '20', '50', '100', '200']"
            :defaultPageSize="50"
            @change="currentChange"
            @showSizeChange="onShowSizeChange"
          />
        </div>
        
      </div>
      <div v-else class="empty-info">
        <div class="empty-box">
          <p style="margin-bottom: 10px"><a-icon style="font-size: 36px" type="bell" /></p>
          <p class="til">近6个月未收到消息</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { getInformList, getInformListSmall, deleteMessage, putMessageReady, lookMessageStatus, selectSmallCompany, getMessageChange } from '@/api/message';


import {formatDate, dateDiff} from '@/utils/date';
import {getFileSuffix, isAssetTypeAnImage, isAssetTypeOther} from '@/utils/index'

export default {
  name: 'informCenter',
  components: {},
  data() {
    return {
      roleId: '',
      currentIndex: '0',
      tabs: [],
      checkAll: false,
      newsList: [],
      loading: true,
      read: '2',
      type: 'product',
      selectVal: '2',
      ifDisabled: false,
      deptType: null,
      companyList:[],
      deptId:'',
      page: 1,
      size: 50,
      total: 50,
      // name:'',
    
    }
  },
  mounted() {
    this.roleId = this.$store.state.user.roles;
  },
  created() {
    this.lookMessageStatus();
    this.getCompanyList ();
    this.$bus.$on('hasReadyTop', () => {
      this.getInformList(this.read, this.type);
    })
  },
  destroyed() {
    this.$bus.$off("hasReadyTop");
  },
  methods: {
    currentChange(current, pageSize) {
      this.page = current;
      this.getInformList(this.read, this.type, this.deptId);
    },
    onShowSizeChange(current, pageSize) {
      this.size = pageSize;
      this.page = 1;
      this.getInformList(this.read, this.type, this.deptId);
    },
    lookMessageStatus() {
      lookMessageStatus()
        .then(res => {
          let type = res[0].code;
          this.getInformList(this.read, type);
          this.tabs = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getInformList(read, type, deptId) {
      this.deptId = deptId == undefined ? '' : deptId;
      let params = {
        read,
        type,
        deptId: this.deptId,
        page: this.page - 1,
        size: this.size
      }
      getInformList(params)
        .then(res => {
          this.loading = false;
          if (res && res.length > 0) {
            res.map(i => {
              i.selected = false;
            })
            let result = res.find(i =>{
                return i.unread
            });
            if (result) {
              this.ifDisabled = false;
            } else {
              this.ifDisabled = true;
            }
          }
          this.newsList = res.content;
          this.total = res.totalElements;
        })
        .catch(error => {
          console.log(error);
        })
    },
    tabSelect(index) {
      this.page = 1;
      this.size = 50;
      this.currentIndex = index;
      let type = this.tabs[index].code;
      this.loading = true;
      this.getInformList(this.read, type);
      this.type = type;
      this.selectVal = '2';
      this.checkAll = false;
    },
    onCheckAllChange(e) {
      let checked = e.target.checked;
      if (checked) {
          this.newsList.map((i) => {
              i.selected = true;
          })
      } else {
          this.newsList.map((i) => {
              i.selected = false;
          })
      }
    },
    onChange(e) {
      
    },
    handleChange(e) {
      this.read = e;
      this.loading = true;
      this.getInformList(this.read, this.type);
    },
    selectCompanyAction(value) {
      this.loading = true;
      this.getInformList(this.read, this.type, value);
      
    },
   
     /**
     * 企业信息
     */
    async getCompanyList () {
      try {
        const data = await selectSmallCompany()
        this.companyList = JSON.parse(JSON.stringify(data))
        
      } catch (error){
        console.log(error)
      }
    },
    delAction() {
      let delArr = []
      this.newsList.map(i => {
        if (i.selected) {
          delArr.push(i.id)
        }
      })
      if (delArr.length > 0) {
        this.deleteMessage(delArr);
      } else {
        this.$message.error('请先选择消息');
      }
    },
    deleteMessage(params) {
      let that = this;
      that.$confirm({
            title: '确定要删除吗',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
              deleteMessage(params)
                .then(res => {
                  that.getInformList(that.read, that.type);
                  that.lookMessageStatus();
                  that.$bus.$emit('hasReady')
                })
                .catch(error => {
                  console.log(error);
                })
            },
        })
    },
    putMessageReady() {
      let that = this;
      that.$confirm({
            title: '确定全部标识为已读吗',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
              putMessageReady(that.type)
              .then(res => {
                that.getInformList(that.read, that.type);
                that.lookMessageStatus();
                that.$bus.$emit('hasReady')
              }) 
              .catch(error => {
                console.log(error);
              })
            },
        })
    },
    goDetail(item) {
      if (item.detailType == '2') {
        this.$router.push({path: '/user/messageChange', query: {id: item.id}})
      } else if (item.detailType == '1') {
        this.$router.push({path: '/user/messageStandard', query: {id: item.id}})
      } else if (item.detailType == '4') {
        this.$router.push({path: '/detection/orderManage'})
        this.getMessageChange(item)
      } else if (item.detailType == '3') {
        // 账号消息，只标记为已读
        this.getMessageChange(item)
        
      }
    },
    // 设置消息为已读
    getMessageChange(item) {
      getMessageChange(item.id)
        .then(res => {
          // console.log('已读成功')
          if(item.detailType == '3') {
            item.unread = false
          }
          this.$bus.$emit('reloadTop');
        })
        .catch(err => {
          console.log(err);
        })
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    dateDiff(time){
      return dateDiff(time);
    },
    spliceChinese(val) {
      if (val) {
        var reg = /[\u4e00-\u9fa5]/g;
        if (val.match(reg)) {
            return val.match(reg).join('');
          } else {
            return val;
          }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.item-type {
    display: inline-block;
    width: 200px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;
    vertical-align: middle;
    cursor: pointer;
}
.inform-center {
  background-color: #fff;
  overflow: hidden;
  height: 100%;
  padding: 0 20px;
  .tab-box {
    width: 100%;
    height: 51px;
    background-color: #fff;
    border-bottom: 1px solid #c1c1c1;
    box-sizing: border-box;
    .tabs {
      width: 100%;
      li {
        color: #909399;
        background-color: #fff;
        float: left;
        width: 120px;
        text-align: center;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        margin-right: 20px;
        position: relative;
        .item {
          position: absolute;
          top: -8px;
          right: 5px;
        }
      }
      li.active {
          height: 50px;
          line-height: 50px;
          border-bottom: 2px solid #40a9ff;
          color: #40a9ff;
      }
    }
  }
  .info-box {
    height: 100%;
    .action-box {
      height: 40px;
      line-height: 40px;
      margin-top: 10px;
      padding: 0 10px; 
    }
    .list-box {
      height: 100%;
      overflow-y: auto;
      padding-bottom: 150px;
      .info-list {
        padding: 10px;
        border-bottom: 1px solid #f2f2f2;
        font-size: 14px;
        position: relative;
        .til {
          margin-left: 15px;
        }
        .content {
          text-indent: 30px;
          display: inline-block;
          max-width: 800px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow:ellipsis;
          vertical-align: middle;
          margin-top: 10px;
        }
        .pointer {
          cursor: pointer;
        }
        .time {
          position: absolute;
          top: 15px;
          right: 20px;
          color: #c1c1c1;
        }
      }
      .gray {
        color: #c1c1c1;
      }
      .info-list:hover {
        background-color: #E6F7FF;
      }
    }
  }
  .empty-info {
    height: 100%;
    position: relative;
    .empty-box {
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      color: #c1c1c1;
    }
  }
}
.pagination-layout {
  display: flex;
  justify-content:flex-end;
  margin-top: 15px;
}
</style>

